import Icon from '../components/Icon.vue'

Icon.register({"certificate":{"width":512,"height":512,"paths":[{"d":"M458.6 255.9L504.6 210.9C518.3 197.9 511.9 174.9 493.9 170.6L431.3 154.6 449 92.6C453.9 74.7 437.1 57.9 419.3 62.9L357.3 80.6 341.3 17.9C337.1 0.2 313.8-6.3 301 7.2L256 53.6 211 7.2C198.4-6.1 175 0 170.7 17.9L154.7 80.6 92.7 62.9C74.9 57.9 58.1 74.7 63 92.6L80.7 154.6 18.1 170.6C0.1 174.9-6.3 197.9 7.4 210.9L53.4 255.9 7.4 300.9C-6.3 313.9 0.1 337 18.1 341.3L80.7 357.3 63 419.3C58.1 437.1 74.9 453.9 92.7 448.9L154.7 431.3 170.7 493.9C175.1 512.5 198.4 518 211 504.6L256 458.6 301 504.6C313.5 518.1 337 512.1 341.3 493.9L357.3 431.3 419.3 448.9C437.1 453.9 453.9 437.1 449 419.3L431.3 357.3 493.9 341.3C511.9 337 518.3 313.9 504.6 300.9L458.6 255.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/certificate.js
// module id = null
// module chunks = 